module.exports = __webpack_public_path__ + "7ebe01def7f4e2c96351f1c0d544f51d.png";